import React from 'react';
// import { Navigate } from 'react-router-dom';
import MainLayout from 'layouts/main-layout';
import AuthLayout from 'layouts/auth-layout';
import ForbiddenPage from 'pages/errors/forbidden-view';
import NotFoundPage from 'pages/errors/notfound-view';
import Register from 'pages/auth/register/register-view-form';
import Login from 'pages/auth/login/login-form';
import ForgotPassword from 'pages/auth/forgot-password/forgot-password-form';
import ResetPasswordForm from 'pages/auth/forgot-password/reset-password-form';
// import ActivateAccount from 'pages/auth/register/activate-account-form';
import Campaign from 'pages/admin/campaign/campaign-list';
import EmailSubscription from 'pages/auth/email/subscription';
import Profile from 'pages/profile/profile';
import ChangePassword from 'pages/profile/change-password';
import SurveyLayout from 'layouts/survey-layout';
import PreviewSurvey from 'pages/admin/survey/preview/preview-survey';
import Survey from 'pages/admin/survey/survey';
import CampaignOverview from 'pages/admin/campaign-overview/components/campaign-overview';
import CampaignDesign from 'pages/admin/campaign-design/campaign-design';
import CampaignDataCollection from 'pages/admin/campaign-data-collect/collect-data';
import SurveyActive from 'pages/admin/campaign-data-collect/components/survey-active';
import ServicePayment from 'pages/admin/campaign-data-collect/components/service-payment';
import PaymentResults from 'pages/admin/campaign-data-collect/components/payment-results';
import CampaignDataAnalysis from 'pages/admin/campaign-data-analysis';
import Payment from 'pages/admin/payment';
import PaymentDetail from 'pages/admin/payment/payment-detail';
import PaymentAdd from 'pages/admin/payment/components/payment-add';
import AccountManagement from 'pages/admin/account-management';
import AccountForm from 'pages/admin/account-management/components/account-form';
import Customer from 'pages/admin/customer';
import CustomerForm from 'pages/admin/customer/components/customer-form';
import Configuration from 'pages/admin/configuration';
import CustomerDetail from 'pages/admin/customer/components/customer-detail';
import Overview from 'pages/admin/overview';
import Upgrade from 'pages/admin/upgrade';
import { Role } from 'common/constants';
import PaymentResult from 'pages/admin/payment/components/payment-result';
import PreRegisterForm from 'pages/auth/register/pre-register-form';
import ServicePackagePayment from 'pages/admin/service-package-payment';
import PaymentLayout from 'layouts/payment-layout';
import TargetedSurvey from 'pages/admin/survey/targeted-survey';
import CampaignDesignPageLogic from 'pages/admin/campaign-design-page-logic/campaign-design-page-logic';
import Reward from 'pages/admin/reward';
import UniqLink from 'pages/admin/uniq-link';
import LogicPageSurvey from 'pages/admin/page-logic-survey/logic-page-survey';

const routers = () => {
    return [
        {
            path: '/',
            element: <></>,
        },
        {
            path: '*',
            element: <NotFoundPage />,
        },
        {
            path: '403',
            element: <ForbiddenPage />,
        },
        {
            element: <AuthLayout />,
            children: [
                {
                    path: '/login',
                    element: <Login />,
                },
                {
                    path: '/pre-register',
                    element: <PreRegisterForm />,
                },
                {
                    path: '/register',
                    element: <Register />,
                },
                {
                    path: '/forgot-password',
                    element: <ForgotPassword />,
                },
                {
                    path: '/reset-password/',
                    element: <ResetPasswordForm />,
                },
                // {
                //     path: '/activate-account',
                //     element: <ActivateAccount />,
                // },
            ],
        },

        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER, Role.CLIENT, Role.SALES],
            children: [
                {
                    path: 'campaign/overview/:id',
                    element: <CampaignOverview />,
                },
                {
                    path: 'campaign',
                    element: <Campaign />,
                },
                {
                    path: 'campaign/:id',
                    element: <CampaignOverview />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER, Role.CLIENT, Role.ACCOUNTANT, Role.SALES],
            children: [
                {
                    path: 'overview',
                    element: <Overview />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER, Role.CLIENT, Role.ACCOUNTANT, Role.SALES],
            children: [
                {
                    path: 'profile',
                    element: <Profile edit={false} />,
                },
                {
                    path: 'profile/edit',
                    element: <Profile edit={true} />,
                },
                {
                    path: 'change-password',
                    element: <ChangePassword />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER, Role.CLIENT, Role.ACCOUNTANT],
            children: [
                {
                    path: 'payment',
                    element: <Payment />,
                },
                {
                    path: 'payment/:id',
                    element: <PaymentDetail />,
                },
                {
                    path: 'payment/:id/result',
                    element: <PaymentResult />,
                },
                {
                    path: 'payment/add',
                    element: <PaymentAdd />,
                    roles: [Role.SUPER, Role.ACCOUNTANT],
                },
            ],
        },
        {
            path: '/admin',
            element: <PaymentLayout />,
            roles: [Role.CLIENT],
            children: [
                {
                    path: 'service-package-payment',
                    element: <ServicePackagePayment />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER],
            children: [
                {
                    path: 'account-management',
                    element: <AccountManagement />,
                },
                {
                    path: 'account-management/add',
                    element: <AccountForm edit={false} />,
                },
                {
                    path: 'account-management/:id/edit',
                    element: <AccountForm edit={true} />,
                },
                {
                    path: 'uniq-link',
                    element: <UniqLink />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER, Role.SALES, Role.ACCOUNTANT],
            children: [
                {
                    path: 'customer',
                    element: <Customer />,
                },
                {
                    path: 'customer/add',
                    element: <CustomerForm edit={false} />,
                },
                {
                    path: 'customer/:id/edit',
                    element: <CustomerForm edit={true} />,
                },
                {
                    path: 'customer/:id',
                    element: <CustomerDetail />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER],
            children: [
                {
                    path: 'general-configuration',
                    element: <Configuration />,
                },
                {
                    path: 'service-pack-configuration',
                    element: <Configuration />,
                },
                {
                    path: 'survey-service-configuration',
                    element: <Configuration />,
                },
                {
                    path: 'discount-configuration',
                    element: <Configuration />,
                },
                // {
                //     path: 'upgrade-service-package',
                //     element: <Upgrade />,
                // },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.CLIENT],
            children: [
                {
                    path: 'upgrade-service-package',
                    element: <Upgrade />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={false} />,
            roles: [Role.SUPER, Role.CLIENT, Role.SALES],
            children: [
                {
                    path: 'campaign/design/:id',
                    element: <CampaignDesign />,
                },
                {
                    path: 'campaign/design/page-logic/:id',
                    element: <CampaignDesignPageLogic />,
                },
                {
                    path: 'campaign/data-collect/:id',
                    element: <CampaignDataCollection />,
                },
                {
                    path: 'campaign/data-collect/:id/survey-active',
                    element: <SurveyActive />,
                },
                {
                    path: 'campaign/data-collect/:id/service-payment',
                    element: <ServicePayment />,
                },
                {
                    path: 'campaign/data-collect/:id/payment-results',
                    element: <PaymentResults />,
                },
                {
                    path: 'campaign/analytics/:id',
                    element: <CampaignDataAnalysis />,
                },
            ],
        },
        {
            path: '/admin',
            element: <MainLayout showSidebar={true} />,
            roles: [Role.SUPER, Role.CLIENT, Role.SALES],
            children: [
                {
                    path: 'reward',
                    element: <Reward />,
                },
            ],
        },
        {
            path: '/survey',
            element: <SurveyLayout />,
            children: [
                {
                    path: ':id',
                    element: <Survey />,
                },
                {
                    path: 'page-logic/:id',
                    element: <LogicPageSurvey />,
                },
                {
                    path: 'preview/:id',
                    element: <PreviewSurvey />,
                },
                {
                    path: 'invite/:id',
                    element: <TargetedSurvey />,
                },
            ],
        },
        {
            path: '/email-subscription',
            element: <EmailSubscription />,
        },
    ];
};

export default routers;
